import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#10374A',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function CustomizedWishlistTables(props: any) {
  const confirmDelete = (item: any) => {
    props.setEditItem && props.setEditItem(item);
    props.setPermModal && props.setPermModal(true);
  };
  return (
    <TableContainer component={Paper} sx={{ marginTop: "20px", maxHeight: 600 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {props.columns?.map((column: any) => (
              <StyledTableCell
                key={column.key}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </StyledTableCell>
            ))}
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data?.map((row: any) => {
            return (
              <TableRow key={row.id}>
                {props.columns.map((column: any) => {
                  return (
                    <TableCell key={column.key}>
                      {column.key === 'images'
                        ? row[column.key].map((el: any) => <img src={el} alt={el} width={50} />)
                        : row[column.key]}
                    </TableCell>
                  );
                })}
                <TableCell>
                  <Box sx={{ display: "flex" }}>
                    <IconButton
                      color="secondary"
                      sx={{
                        backgroundColor: "#10374A", // Custom background color
                        color: "#FFFFFF", // Custom text color
                        "&:hover": {
                          backgroundColor: "#08293D", // Custom hover color
                        },
                      }}
                      onClick={() => confirmDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
